import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/static-property-placement */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@sainsburys-tech/bolt';

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false,
      errorCount: 0
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch() {
      var _this$props = this.props,
          retries = _this$props.retries,
          callbackFunction = _this$props.callbackFunction,
          retryFunction = _this$props.retryFunction;
      var errorCount = this.state.errorCount;

      if (retries >= 1 && errorCount + 1 <= retries) {
        if (typeof retryFunction === 'function') retryFunction.apply(void 0, arguments);
        this.setState({
          errorCount: errorCount + 1
        });
        return;
      }

      if (typeof callbackFunction === 'function') callbackFunction.apply(void 0, arguments);
      this.setState({
        hasError: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          retries = _this$props2.retries,
          showErrorMsg = _this$props2.showErrorMsg,
          errorMsg = _this$props2.errorMsg,
          FallbackComponent = _this$props2.FallbackComponent,
          alertProps = _this$props2.alertProps;
      var _this$state = this.state,
          errorCount = _this$state.errorCount,
          hasError = _this$state.hasError;

      if (retries >= 1 && errorCount > retries || hasError) {
        if (showErrorMsg) return /*#__PURE__*/React.createElement(Alert, alertProps, errorMsg);
        if (FallbackComponent) return FallbackComponent;
        return null;
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(React.Component);

_defineProperty(ErrorBoundary, "defaultProps", {
  retries: 0,
  showErrorMsg: false,
  errorMsg: "Oops, something's gone wrong. We're working hard to fix it... please try again later.",
  alertProps: {
    kind: 'error',
    isCloseable: false
  }
});

_defineProperty(ErrorBoundary, "propTypes", {
  /**
   * Customize the alert message if needed
   */
  alertProps: PropTypes.shape({
    isCloseable: PropTypes.bool,
    kind: PropTypes.string
  }),

  /**
   * Callback fired when an error is caught and the retries are exhausted, causing the fallback to show
   */
  callbackFunction: PropTypes.func,

  /**
   * Callback fired when an error is caught and the render is retried
   */
  retryFunction: PropTypes.func,

  /**
   * Specify the content of your ErrorBoundary
   */
  children: PropTypes.node,

  /**
   * If showErrorMsg, then you can define a custom error message
   */
  errorMsg: PropTypes.string,

  /**
   * If error is caught, display a custom component
   */
  FallbackComponent: PropTypes.element,

  /**
   * Set the amount of times to retry a success state until error is captured
   */
  retries: PropTypes.number,

  /**
   * If error is caught, to show or not to show the error message
   */
  showErrorMsg: PropTypes.bool
});

export default ErrorBoundary;